import { render } from "./DocumentInfoExtended.vue?vue&type=template&id=7965b7d9&scoped=true"
import script from "./DocumentInfoExtended.vue?vue&type=script&lang=js"
export * from "./DocumentInfoExtended.vue?vue&type=script&lang=js"

import "./DocumentInfoExtended.vue?vue&type=style&index=0&id=7965b7d9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7965b7d9"]])

export default __exports__